import React  from 'react'
import {FieldViewProps} from "../../../render/view";
import Votes from "../../../../model2/voting/votes";
import {ALL_REACTIONS} from "../../../../model2/reaction/const";
import EmojiSymbolDeprecated from "../../../../gd-components/icons/common/emoji/emoji-symbol";


// const debug = "FieldVoting_View"
const debug = false

// something wrong here ?

export default function FieldVoting_View(props:FieldViewProps) {

    debug && console.log(debug, 'render fieldId=', props.field.fieldId, "model=", props.model)

    const value = props.field.getViewValue(props.model)

    const votes : Votes = Votes.initFromJson(value)

    // @ts-ignore
    const voteIcon : any = ALL_REACTIONS[props.field.voteIcon]

    if (votes.isEmpty) return null

    const reactionClass = Classes('reaction-view disabled',{
        'my-reaction'   : votes.hasAlreadyVoted
    })

    return (
        <div className="ui5-reactions">
            <div className={reactionClass}>
                <div className="reaction-emoji">
                    <EmojiSymbolDeprecated symbol={voteIcon} size="15" />
                </div>
                <div className="reaction-count">{votes.total}</div>
            </div>
        </div>
    )

}
